import { render } from "./TagInput.vue?vue&type=template&id=21daa8bd&ts=true"
import script from "./TagInput.vue?vue&type=script&lang=ts"
export * from "./TagInput.vue?vue&type=script&lang=ts"

import "./TagInput.vue?vue&type=style&index=0&id=21daa8bd&lang=css"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__